import { useState } from 'react';

import { InternalQuestionGroups, usePicturesContext, useSubmissionContext } from '../../contexts';

export const useMainView = () => {
  const [visibleItems, setVisibleItems] = useState(0);
  const { submitStructure } = useSubmissionContext();
  const { getNumberOfPicturesUploading, getNumberOfPicturesFailed } = usePicturesContext();

  const filteredQG = (questionGroups: InternalQuestionGroups[]) =>
    questionGroups?.filter(
      (questionGroup) => questionGroup.active || (questionGroup.answered && questionGroup.visible),
    ) || [];

  const hasContentSizeChanged = (questionGroups, lastActiveQuestionGroup) => {
    const filteredQuestionGroups = filteredQG(questionGroups);
    const itemCount = filteredQuestionGroups.length;
    setVisibleItems(itemCount);
    if (visibleItems < itemCount || lastActiveQuestionGroup === filteredQuestionGroups[itemCount - 1]) {
      return true;
    }
    return false;
  };

  const stillUploadingPictures = getNumberOfPicturesUploading() > 0;
  const hasFailedPictures = getNumberOfPicturesFailed() > 0;
  // TODO: port to useCallback. VCP-130
  const handleSubmit = (options?: { forceSubmission?: boolean; success?: () => void; failed?: () => void }) => {
    if (options?.forceSubmission || (!hasFailedPictures && !stillUploadingPictures)) {
      submitStructure();
      options?.success?.();
    } else {
      options?.failed?.();
    }
  };

  return { filteredQG, hasContentSizeChanged, handleSubmit, hasFailedPictures, stillUploadingPictures };
};
